module.exports = __webpack_public_path__ + "static/media/adrian.34b722f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/adrian.png
// module id = 106
// module chunks = 0